<template>
    <div class="control push-up">
        <div class="row">
            <div class="small-12 columns">
                <h3 v-html="title" />
            </div>
        </div>
        <div
            v-if="description != ''"
            class="row"
        >
            <div class="small-12 columns">
                <p v-html="description" />
            </div>
        </div>
        <div class="row">
            <div class="small-6 medium-4 columns">
                <label
                    for="files"
                    class="button text-center"
                    data-test="file-attach-button"
                    v-html="addFileLabel"
                />
                <input
                    id="files"
                    ref="files"
                    type="file"
                    multiple
                    class="show-for-sr"
                    @change="onFileChange"
                >
                <!-- eslint-disable max-len -->
                <input
                    v-model="files"
                    v-validate="required + '|file_bundle_size:'
                        + maxFileBundleSize + '|ext:pdf,doc,docx,xps,txt,eml,html,ppt,pptx,xbrl,xml,xls,xlsx,vcs,ai,bmp,jpeg,cr2,eps,gif,jpg,png,indd,psd,wmv,avi,mp4,m4v,pt,zip,wav,3gp,mp4,mp3,m4a|file_already_selected|file_size_exists'"
                    :data-vv-as="dataVvAs"
                    type="hidden"
                    name="files"
                >
            </div>
            <div class="row">
                <div class="small-12 columns">
                    <div
                        v-if="files.length"
                        class="info-box is-open info-box-align-right"
                    >
                        <div
                            v-for="(file, key) in files"
                            :key="key"
                            class="row align-middle conversion-item"
                        >
                            <!-- <div class="small-1 columns">
                                <font-awesome-icon
                                    icon="file"
                                    style="color: #5691B4;"
                                    size="lg" />
                            </div>  -->
                            <div
                                :data-test="'file-attach-file-' + key"
                                class="small-11 columns"
                            >
                                {{ file.name }} - {{ sizeOf(file.size) }}
                            </div>
                            <div class="small-1 columns">
                                <a
                                    :data-test="'data-test-remove-file-' + key"
                                    class="link-icon"
                                    @click="removeFile(key)"
                                >
                                    <i
                                        :title="decodeHTML(removeFileLabel)"
                                        class="icon-trash"
                                    />
                                </a>
                            </div>
                            <div
                                v-if="key < (files.length - 1)"
                                class="small-12 columns"
                            >
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-12 columns">
                <v-error
                    :overrides="{ required: decodeHTML(dataVvAs) + ' skal vedhæftes' }"
                    name="files"
                />
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faFile } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { forEach } from 'lodash';

// library.add(faFile);

export default {
    name: 'FileAttach',
    inject: ['$validator'],
    // components: {FontAwesomeIcon},
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default: 'Filer:'
        },
        description: {
            type: String,
            default: ''
        },
        addFileLabel: {
            type: String,
            default: '+ Tilføj fil(er)'
        },
        removeFileLabel: {
            type: String,
            default: 'Fjern fil'
        },
        maxFileBundleSize: {
            type: Number,
            default: 40960
        },
        dataVvAs: {
            type: String,
            default: 'Vedhæftet fil'
        },
        required: {
            type: String,
            default: 'required'
        }
    },
    computed: {
        files() {
            return this.value;
        },
        fileBundleSize() {
            var size = 0;
            for (var i in this.files) {
                size += this.bytesToKiloBytes(this.files[i].size);
            }
            return size;
        }
    },
    watch: {
        value(val) {
            this.files = val;
        }
    },
    created() {
        var vm = this;

        this.$validator.extend('file_already_selected', () => {
            for (var i = 0; i < vm.files.length; i++) {
                var currentItemI = vm.files[i];

                for (var j = 0; j < vm.files.length; j++) {
                    if (i !== j) {
                        var currentItemJ = vm.files[j];
                        if (currentItemI.name === currentItemJ.name) {
                            return false;
                        }
                    }
                }
            }
            return true;
        });

        this.$validator.extend('file_size_exists', () => {
            for (var i = 0; i < vm.files.length; i++) {
                var currentItem = vm.files[i];
                if (currentItem.size === 0) {
                    return false;
                }
            }
            return true;
        });

        this.$validator.extend('file_bundle_size', (value, size) => vm.fileBundleSize < [size],
            ['size']);
    },
    mounted() {
        this.files = this.value;
    },
    methods: {
        onFileChange() {
            const uploadedFiles = this.$refs.files.files;

            for (var i = 0; i < uploadedFiles.length; i++) {
                this.value.push(uploadedFiles[i]);
            }

            event.target.value = null;
        },
        removeFile(key) {
            this.value.splice(key, 1);
        },
        sizeOf(bytes) {
            if (bytes == 0) {
                return '0.00 B';
            }
            var e = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'B';
        },
        bytesToKiloBytes(byteValue) {
            return Math.ceil(byteValue / 1024);
        },
        decodeHTML(html) {
            var txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value.replace(/<(?!br\s*\/?)[^>]+>/g, '');
        }
    }
};
</script>
